<template>
<div>
  <CChartDoughnut class="w-100"
  v-if="dataSets.length==0"
    :datasets="emptyDatasets"
    :labels="['']"
    :options="emptyOptions"
  />
  <CChartDoughnut class="w-100"
  v-else
    :datasets="defaultDatasets"
    :labels="chartLabels"
    :options="computedOptions"
  />
  </div>
</template>

<script>
import { CChartDoughnut } from 'vue-chartjs-new'
import { getColor, deepObjectsMerge } from '@coreui/utils/src'
export default {
  name: 'CChartDoughnutChart',
  components: { CChartDoughnut },
   props: {
    ...CChartDoughnut.props,
    dataSets: {
      type: Array,
      default: []
    },
    chartLabels: {
      type: Array|String,
      
    },
   },
  computed: {
     emptyDatasets () {
      return [
        {
          backgroundColor: [
            '#B8B8B8',
          ],
          data: ["100"],
          label: ['']
        }
      ]
    },

    defaultDatasets () {
      return [
        {
          backgroundColor: [
            '#137eff',
            '#5ac146',
            '#eceff1'
          ],
          data: this.dataSets,
          label: [this.$t('dashBoard.cChartDoughnut.ticketingQueue'), this.$t('dashBoard.cChartDoughnut.issuedBookings'), this.$t('dashBoard.cChartDoughnut.failedBookings')]
        }
      ]
    },

    emptyOptions(){
      const options = this.straightEmptyOptions
      
       return Object.assign({}, options, {
        cutoutPercentage: 60,
         aspectRatio: 1,
         responsive: true,
        legend: {
          display: false
        }
      })
    },
    defaultOptions(){
      const options = this.straightOptions
      
       return Object.assign({}, options, {
        cutoutPercentage: 60,
         aspectRatio: 1,
         responsive: true,
        legend: {
          display: false
        }
      })
    },
     straightEmptyOptions () {
      return {
        
        tooltips: {
             enabled: false
                
            },
      }
    },
    straightOptions () {
      return {
        
        tooltips: {
                
                callbacks: {
                    label: function(tooltipItems, data) { 
                        // return data.datasets[tooltipItems.datasetIndex];
                        // if(data.datasets[tooltipItems.datasetIndex].backgroundColor[tooltipItems.index]!="#B8B8B8") {
                        let label = data.labels[tooltipItems.index]?data.labels[tooltipItems.index]:' ';
                        // let value = data.datasets[tooltipItems.datasetIndex].label[tooltipItems.index]+' '+data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';
                        return [label]; 
                        // }
                        // else{
                        //   return '';
                        // }             
                        // return data.datasets[tooltipItems.datasetIndex].label[tooltipItems.index]+' '+data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';     }
                },
                afterLabel:function (tooltipItems, data) {
                        let value = data.datasets[tooltipItems.datasetIndex].label[tooltipItems.index]+' (%) : '+data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
                  return [value]; 
                }
                
                }
            },
      }
    },
    computedDatasets () {
      return deepObjectsMerge(this.defaultDatasets, this.datasets || {})
    },
    computedOptions () {
      return deepObjectsMerge(this.defaultOptions, this.options || {})
    }
  }
}
</script>
